import { ModalBody, ModalHeader, Button } from 'reactstrap'
import _isNil from 'lodash/fp/isNil'
import { useDispatch, useSelector } from 'react-redux'
import { getIcon } from 'e-submission/components/Icon'
import { Modal } from 'common-components/index'
import { setAppValue } from '../../../apps/actions'
import { Link } from 'react-router-dom'
import { getToggles } from 'quick-quote/feature-toggles'
import {
  getSkippedInsuredEkyc,
  getSkippedPayerEkyc,
} from 'e-submission/domain/data-model/form/selectors'
import { getCurrentApp } from 'e-submission/apps/selectors'


const SubmitButton = ({
  onExit,
  isInvalid = false,
  removeError,
  setSkippedEkyc,
  insuredDopaVerified,
  payerDopaVerified,
  insuredDopaRequestFailed,
  payerDopaRequestFailed,
  insuredDopaResultResponseDataMessage,
  payerDopaResultResponseDataMessage,
  appStateIsSkippedInsuredEkyc,
  appStateIsSkippedPayerEkyc,
}) => {
  const isSkippedInsuredEKYC =
    (!insuredDopaVerified && insuredDopaRequestFailed) ||
    !(insuredDopaResultResponseDataMessage || 'สถานะปกติ').includes('สถานะปกติ')
  const isSkippedPayerKYC =
    (!payerDopaVerified && payerDopaRequestFailed) ||
    !(payerDopaResultResponseDataMessage || 'สถานะปกติ').includes('สถานะปกติ')
  return (
    <div className={'normal-text detail-text button-submit'}>
      <Link to="document">
        <Button
          color={isInvalid ? 'disabled' : 'primary'}
          className="primary"
          onClick={() => {
            if (!appStateIsSkippedInsuredEkyc) setSkippedEkyc('insured', isSkippedInsuredEKYC)
            if (!appStateIsSkippedPayerEkyc) setSkippedEkyc('payer', isSkippedPayerKYC)
            removeError()
            onExit()
          }}
        >
          ตกลง
        </Button>
      </Link>
    </div>
  )
}

export const DopaRequestFailedModal = ({
  isOpen,
  onExit,
  insuredDopaVerified,
  payerDopaVerified,
  insuredDopaRequestFailed,
  payerDopaRequestFailed,
  isInvalid,
  insuredDopaResultResponseDataMessage,
  payerDopaResultResponseDataMessage,
}) => {
  const dispatch = useDispatch()

  const { appStateIsSkippedInsuredEkyc, appStateIsSkippedPayerEkyc } = useSelector((state) => {
    const app = getCurrentApp(state)
    return {
      appStateIsSkippedInsuredEkyc: getSkippedInsuredEkyc(state),
      appStateIsSkippedPayerEkyc: getSkippedPayerEkyc(app),
    }
  })
  const removeError = () => {
    dispatch(removeError('EKYC_VERIFY_CITIZENID'))
  }
  const setSkippedEkyc = (key, value) => {
    if (!_isNil(value)) {
      dispatch(setAppValue(`ekycInfo.${key}.skipped`, value))
    }
  }

  const mapText = {
    verifiedFail: {
      title: 'พบปัญหาการยืนยันตัวตนกับระบบ DOPA',
      description1: 'เนื่องจากผลการยืนยันตัวตนกับ DOPA ไม่ผ่าน',
      description2: 'กรุณาขอเอกสารเพิ่มเติมเพื่อดำเนินการยืนยันตัวตนเบื้องต้นในขั้นตอนต่อไป',
    },
    dopaFail: {
      title: 'ขณะนี้ระบบ DOPA ขัดข้อง',
      description1: 'กรุณาขอเอกสารเพิ่มเติมเพื่อดำเนินการยืนยันตัวตนเบื้องต้น',
      description2: 'ระบบจะแจ้งให้ทราบเมื่อขั้นตอน ยืนยันกับ DOPA เสร็จสิ้น',
    },
  }

  if (getToggles().ENABLE_DISABLE_SECOND_DOC) {
    mapText.dopaFail = {
      title: 'ขณะนี้ระบบยืนยันตัวตนกับกรมการปกครองขัดข้อง',
      description1: 'ระบบจะแจ้งผลการยืนยันตัวตนให้ทราบหลังจากที่ระบบ',
      description2: 'กลับมาใช้งาน กรุณากดปุ่มตกลงเพื่อไปยังขั้นตอนถัดไป',
    }
  }

  let text = mapText.dopaFail

  const verifiedFailed =
    (!_isNil(insuredDopaVerified) && !insuredDopaVerified) || (!_isNil(payerDopaVerified) && !payerDopaVerified)
  const dopaFailed = insuredDopaRequestFailed || payerDopaRequestFailed
  if (verifiedFailed && !dopaFailed) text = mapText.verifiedFail

  return (
    <Modal
      className={'identify-ekyc-responding-modal'}
      isOpen={isOpen}
      size="md"
      modalClassName="default-bootstrap remote-selling-modal"
      toggle={() => {
        onExit()
      }}
    >
      <ModalHeader
        className={'header-modal'}
        toggle={() => {
          onExit()
        }}
      ></ModalHeader>
      <ModalBody>
        <div className={`normal-text`}>{getIcon('ekycStatusWarning')}</div>
        <h5 className={'text-header normal-text'}>{text.title}</h5>
        <div className={'normal-text detail-text'}>{text.description1}</div>
        <div className={'normal-text detail-text'}>{text.description2}</div>
        <SubmitButton
          appStateIsSkippedInsuredEkyc={appStateIsSkippedInsuredEkyc}
          appStateIsSkippedPayerEkyc={appStateIsSkippedPayerEkyc}
          onExit={onExit}
          isInvalid={isInvalid}
          removeError={removeError}
          setSkippedEkyc={setSkippedEkyc}
          insuredDopaVerified={insuredDopaVerified}
          payerDopaVerified={payerDopaVerified}
          insuredDopaRequestFailed={insuredDopaRequestFailed}
          payerDopaRequestFailed={payerDopaRequestFailed}
          insuredDopaResultResponseDataMessage={insuredDopaResultResponseDataMessage}
          payerDopaResultResponseDataMessage={payerDopaResultResponseDataMessage}
        />
      </ModalBody>
    </Modal>
  )
}

const DopaRequestFailed = DopaRequestFailedModal

export default DopaRequestFailed
